<template>
  <div class="container">
    <van-list
      style="width: 100%"
      v-model="loading"
      :finished="finished"
      finished-text="— 我是有底线的 —"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" style="margin: 15px 0">
        <!-- <div>{{item.date}}</div> -->

        <article-card-item
          v-if="item.type == 1"
          :index="index"
          :data="item"
          :onClickCollect="onClickCollect"
          :onArticleClick="onArticleClick"
        />
        <!-- <div v-if="item.type == 1">
          <date-label
            v-if="item.article.issueDate"
            :date="item.article.issueDate"
          ></date-label>
          <div class="card-item" @click="onArticleClick(item.article)">
            <div class="article-image-container">
              <div>
                <img class="article-intro-image" :src="item.article.imageUrl" />
                <img
                  v-if="!item.article.isFree"
                  class="vip-icon"
                  :src="require('../../../assets/imgs/collect/collect_vip.png')"
                />
                <img
                  v-if="item.article.isFree"
                  class="vip-icon"
                  :src="
                    require('../../../assets/imgs/collect/collect_free.png')
                  "
                />
              </div>
            </div>
            <div v-if="item.article.keyword" class="article-catagory">
              — {{ item.article.keyword }} —
            </div>
            <div v-if="item.article.title" class="article-desc-en">
              {{ item.article.title.replace(/&nbsp;/g, " ") }}
            </div>
            <div v-if="item.article.titleCn" class="article-desc-cn">
              {{ item.article.titleCn.replace(/&nbsp;/g, " ") }}
            </div>
            <div
              v-if="item.article.source || item.article.sourceCn"
              class="article-source"
            >
              选自<span v-if="item.article.source"
                >{{ `${item.article.source} ` }} </span
              ><span v-if="item.article.sourceCn">{{
                `(${item.article.sourceCn})`
              }}</span>
            </div>
            <div
              style="
                height: 75px;
                justify-content: center;
                align-items: center;
                display: flex;
                width: 100%;
                position: relative;
              "
            >
              <div
                style="
                  justify-content: center;
                  align-items: center;
                  display: flex;
                  flex-direction: row;
                  position: relative;
                "
              >
                <div
                  style="font-size: 14px; color: #999999; margin-left:15px;line-height: 30px;"
                  >收藏</div
                >
                <lottie
                  style="
                    position: absolute;
                    width: 32px;
                    left: -15px;
                    height: 32px;
                  "
                  @click.native.stop="onClickCollect(item.article, index)"
                  :options="defaultOptions"
                  v-on:animCreated="handleAnimation"
                />
              </div>
              <img
                v-if="item.article.isRead"
                style="
                  width: 69px;
                  height: 69px;
                  position: absolute;
                  right: 0;
                  bottom: 0px;
                "
                :src="
                  require('../../../assets/imgs/collect/collect_readed_bottom.png')
                "
              />
            </div>
          </div>
        </div> -->

        <div v-if="item.type == 2" class="card-item">
          <div class="article-image-container">
            <div>
              <img
                class="article-intro-image"
                :src="item.collection.imageUrl"
              />
            </div>
            <div class="small_pic"></div>
          </div>
          <div style="padding: 0 18px; text-align: center; margin-bottom: 24px">
            <div v-if="item.collection.title" class="article-collection-title">
              {{ item.collection.title.replace(/&nbsp;/g, " ") }}
            </div>
            <div v-if="item.collection.label" class="article-collection-tag">
              {{ item.collection.label }}
            </div>
            <div
              v-if="item.collection.description"
              class="article-collection-desc"
            >
              {{ item.collection.description }}
            </div>
          </div>
          <div class="divider" />
          <div
            v-if="item.collection.articles"
            style="width: 100%; padding: 0 18px"
          >
            <div
              class="article-collection-list-item"
              v-for="article in item.collection.articles"
              :key="article.articleId"
              @click="onArticleClick(article)"
            >
              <div>
                <img
                  class="article-collection-list-item-image"
                  :src="article.subImageUrl"
                />
              </div>
              <div class="article-collection-list-item-text-container">
                <div v-if="article.titleCn" class="article-item-title-cn">
                  {{ article.titleCn.replace(/&nbsp;/g, " ") }}
                </div>
                <div v-if="article.title" class="article-item-title-en">
                  {{ article.title.replace(/&nbsp;/g, " ") }}
                </div>
              </div>
            </div>
          </div>

          <div class="article-collection-more" @click="onMoreClick(item)">
            {{ `查看${item.collection.total}篇精选文章>>` }}
          </div>
        </div>
      </div>
      <template #finished>
        <div style="font-size: 10px">— 我是有底线的 —</div>
      </template>
    </van-list>
  </div>
</template>

<script>
import moment from "moment";
import lottie from "vue-lottie";
import DateLabel from "./component/DateLabel";
import ArticleCardItem from "./component/ArticleCardItem";
import { getRecommendArticleList, getTodayArticle } from "../../../api/article";
import _ from "lodash";
import Anim from "../../../assets/lottie/lottie-collect.json";
import { joidCollections, removeCollections } from "../../../api/collection.js";
import { Toast } from "vant";

export default {
  name: "RecommendList",
  components: {
    lottie,
    DateLabel,
    ArticleCardItem,
  },
  data() {
    return {
      loading: false,
      finished: false,
      pageSize: 6,
      pageIndex: 1,
      list: [
        //
      ],
      defaultOptions: { animationData: Anim, loop: false, autoplay: false },
      defaultAnim: "",
      showAin: false,
    };
  },
  activated() {
    console.log("========> on activated");
  },
  mounted() {
    getTodayArticle()
      .then((result) => {
        if (!result.data) {
          return;
        }
        let article = result.data;
        this.list = _.concat([], { article: article, type: 1 }, this.list);
      })
      .catch((error) => {});
  },
  methods: {
    //==============lottie================
    handleAnimation(anim) {
      this.defaultAnim = anim;
      console.log("anim", anim);
    },
    action_collect_success(index) {
        this.list = _.map(this.list, (item, idx) => {
          if (index == idx) {
            return _.assign({
              ...item,
              article: { ..._.assign({ ...item.article, isFavorite: true }) },
            });
          } else {
            return item;
          }
        });
        console.log("====>", this.list);
    },
    onClickCollect(article, index) {
      console.log("onClickCollect", article, index);
      let param = {
        articleId: article.articleId,
      };
      if (article.isFavorite) {
        //已收藏
        removeCollections(param)
          .then((res) => {
            this.list = _.map(this.list, (item, idx) => {
              if (index == idx) {
                return _.assign({
                  ...item,
                  article: {
                    ..._.assign({ ...item.article, isFavorite: false }),
                  },
                });
              } else {
                return item;
              }
            });
          })
          .catch((err) => {})
          .finally(() => {});
      } else {
        //动画
        joidCollections(param)
          .then((res) => {
            this.action_collect_success(index);
            Toast.success({duration: 500,message: "收藏成功"});
          })
          .catch((err) => {
            // console.log('error = ', err)
            // Toast.fail("收藏失败");
          })
          .finally(() => {});
      }
    },
    onLoad() {
      getRecommendArticleList({
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      })
        .then((result) => {
          this.list = _.concat(this.list, result.data.records);
          this.pageIndex++;
          this.loading = false;
          if (result.data.records.length < this.pageSize) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    onMoreClick(item) {
      this.$router.push({
        path: "/moreArticle",
        query: { collectionId: item.collection.collectionId },
      });
    },
    onArticleClick(item) {
      this.$router.push({
        path: "/articleGuide",
        query: { articleId: item.articleId },
      });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  padding: 0 3vw;
  display: flex;
}

.divider {
  background-color: #e3e3e3;
  height: 1px;
  width: 90%;
}

// .tab-item-text {
// color: #3994E7;
// }
.card-item {
  // background-color :
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 20px 100px 0px #d6d6d6;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.article-image-container {
  display: flex;
  position: relative;
  text-align: center;
}

.article-intro-image {
  position: relative;
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.article-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12vw;
  height: 12vw;
  transform: translate(-50%, -50%);
}

.article-catagory {
  margin-top: 24px;
  font-size: 13px;
  font-weight: bold;
  color: #999999;
  font-family: serif, SimSun, STSong;
}

.article-desc-en {
  margin: 0 15px;
  margin-top: 24px;
  font-size: 14px;
  text-align: center;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-desc-cn {
  margin-top: 15px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  font-family: serif, SimSun, STSong;
}

.article-source {
  margin-top: 15px;
  font-size: 11px;
  color: #999999;
  font-family: serif, SimSun, STSong;
}

.card-container {
  width: 100%;
}

.horizontal-container {
  .scroll-wrapper {
    width: 100%;
    margin: 6px auto;
    white-space: nowrap;
    overflow: hidden;

    .scroll-content {
      display: inline-block;
      vertical-align: center;
    }

    .scroll-item {
      line-height: 100%;
      font-size: 24px;
      display: inline-block;
      text-align: center;
      padding: 0 10px;
    }
  }
}

.article-collection-list-item {
  height: 82px;
  padding: 0 18px;
  display: flex;
  margin: 10px 0;
}

.article-collection-list-item-image {
  width: 82px;
  height: 82px;
  border-radius: 6px;
}

.article-collection-list-item-text-container {
  justify-content: center;
  display: flex;
  margin-left: 10px;
  flex-direction: column;
}

.article-item-title-cn {
  font-family: serif, SimSun, STSong;
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 12px;
}

.article-item-title-en {
  font-family: serif, SimSun, STSong;
  font-size: 11px;
}

.article-collection-title {
  margin-top: 23px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-desc {
  margin-top: 20px;
  font-size: 12px;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-tag {
  margin-top: 20px;
  font-size: 11px;
  color: #3994E7;
  font-family: serif, SimSun, STSong;
}

.article-collection-more {
  // margin: 10px 0 20px 0;
  line-height: 50px;
  color: #3994E7;
  font-size: 12px;
}

.vip-icon {
  width: 45px;
  height: 20px;
  position: absolute;
  right: 15px;
  top: 15px;
}
</style>


// WEBPACK FOOTER //
// app/pages/tabs/Home/RecommendList.vue